import isEqual from 'fast-deep-equal';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export default entityType => {
  const selectEntities = useCallback(state => state.entities[entityType] || {}, [entityType]);
  return useSelector(selectEntities, isEqual);
};
